module.exports = __webpack_public_path__ + "static/media/img-msg-deal.3b10f8c1.png";